<template>
  <div class="not-found content-padding">
    <h1>404</h1>
    <span>страница не найдена. <router-link :to="{name: 'Home'}">Вернуться на главную</router-link> </span>
  </div>

</template>

<script>
export default {
  name: "PageNotFound"
}
</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;

}
</style>
